package pwgs.ui.scenes.projectinvitations

import kotlinx.browser.window


class ProjectInvitationsControllerFe(props: ProjectInvitationsSceneProps, scene: MProjectInvitationsScene) : AProjectInvitationsControllerFe(props, scene) {

    override fun createInitialModel() : ProjectInvitationsSceneModel {
        return ProjectInvitationsSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }

    fun onInviteMemberButtonClicked() {
        model.inviteDialogModel = ProjectInvitationsSceneInviteDialogModel()
        this.render(this.model)
    }

    fun onSendInvitationButtonClicked() {
        model.inviteDialogModel!!.isLoading = true
        this.render(this.model)
        call_inviteUser()
    }

    fun onCancelInviteButtonClicked() {
        model.inviteDialogModel = null
        this.render(this.model)
    }

    fun resendInvitation(id: String) {
        if (!window.confirm("Are you sure you want to resend the invitation email?")) {
            return
        }
        call_resendInvitation(id)
        window.alert("Invitation resent!")
    }

    fun revokeInvitation(id: String) {
        if (!window.confirm("Are you sure you want to revoke the invitation?")) {
            return
        }
        call_revokeInvitation(id)
    }

}

